module.exports = __webpack_public_path__ + "static/media/company-logo-hide.330ae172.png";